import i18next from 'i18next'

export default function t(key, options = {}) {
  return i18next.t(key, options)
}
